/* eslint-disable */
export default [
  {
    component: 'CNavTitle',
    name: 'Dashboard',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Modulos',
  },
  {
    component: 'CNavGroup',
    name: 'Modulos',
    icon: 'cil-browser',
    items: [
      {
        component: 'CNavItem',
        name: 'Usuários',
        icon: 'cil-browser',
        to: '/UsuariosBanca',
      },
      {
        component: 'CNavItem',
        name: 'Log de bilhetes',
        icon: 'cil-browser',
        to: '/LogBancasPremios',
      },
      {
        component: 'CNavItem',
        name: 'Criar Concursos',
        icon: 'cil-browser',
        to: '/CriarConcurso',
      },
      {
        component: 'CNavItem',
        name: 'Enviar Resultados',
        icon: 'cil-browser',
        to: '/EnviarResultado',
      },
      {
        component: 'CNavItem',
        name: 'Excluir Concusrsos',
        icon: 'cil-browser',
        to: '/ExcluirConcurso',
      },
      {
        component: 'CNavItem',
        name: 'Sobrepor Resultados',
        icon: 'cil-browser',
        to: '/Modulo4',
      },
      {
        component: 'CNavItem',
        name: 'Conferência de Bilhetes',
        icon: 'cil-browser',
        to: '/PegaLadrao',
      },
      {
        component: 'CNavItem',
        name: 'Lista de Ganhadores',
        icon: 'cil-browser',
        to: '/modulo3',
      },
      {
        component: 'CNavItem',
        name: 'Lista Ganhadores Bichão',
        icon: 'cil-browser',
        to: '/GanhadoresBichao',
      },
      {
        component: 'CNavItem',
        name: 'Relatório de Vendas Semanais',
        icon: 'cil-browser',
        to: '/RelatorioVendasSemanais',
      },
      {
        component: 'CNavItem',
        name: 'Análise de Faturamento',
        icon: 'cil-browser',
        to: '/Faturamento',
      },
      {
        component: 'CNavItem',
        name: 'Metas e Vendas',
        icon: 'cil-browser',
        to: '/MetasVendas',
      },
      {
        component: 'CNavItem',
        name: 'Consultores (exportação)',
        icon: 'cil-browser',
        to: '/ConsultoresExport',
      },
      {
        component: 'CNavItem',
        name: 'Relatório de Depósitos Semanais',
        icon: 'cil-browser',
        to: '/RelatorioDepositosSemanais',
      },
      {
        component: 'CNavItem',
        name: 'Compradores de combo',
        icon: 'cil-browser',
        to: '/ComboBuyersReport',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Configurações',
    icon: 'cil-browser',
    to: '/config',
  },
  {
    component: 'CNavItem',
    name: 'Perfil',
    icon: 'cil-user',
    to: '/perfil',
  },
  {
    component: 'CNavItem',
    name: 'Saldo de usuários',
    icon: 'cil-browser',
    to: '/UsuariosSaldo',
  },
  {
    component: 'CNavItem',
    name: 'Sua Rifa',
    icon: 'cil-browser',
    to: '/rifa',
  },
  {
    component: 'CNavGroup',
    name: 'Layout',
    icon: 'cil-browser',
    items: [
      {
        component: 'CNavItem',
        name: 'Icones SideBar',
        icon: 'cil-browser',
        to: '/layput/sidebar',
      },
      {
        component: 'CNavItem',
        name: 'Cores Site',
        icon: 'cil-browser',
        to: '/layput/corsite',
      },
      {
        component: 'CNavItem',
        name: 'BtnHome',
        icon: 'cil-browser',
        to: '/layput/btnhome',
      },
    ],
  },
]
